import React from 'react';
import { Form, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification } from 'antd';
import {getLuckyWheel, getCouponsList} from '../../../modules/Api';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class LuckyWheelCouponForm extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            lucky_wheel: {},
            submitted: false,
            allCoupons: [],
            coupons: [],
            selectedCoupons: []
        }

    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            let output = Object.assign({},
                fieldsValue, {
                    coupons: this.state.selectedCoupons.map(t => t.key)
                }
            );
            let max = this.state.lucky_wheel.max_coupons_count;
            let min = this.state.lucky_wheel.max_coupons_count;
            if(output.coupons.length > max || output.coupons.length < min || (output.coupons.length % 2 != 0)) {
                alert("تعداد قرعه کشی ها نمی تواند بیتشر از " + max + " یا کمتر از " + min + " و یا فرد باشد");
                return;
            }
            this.props.submit(output);
        })
    }

    componentDidMount() {
        const id = this.props.initialData.lucky_wheel_id;
        getLuckyWheel(id, (res)=>{
            if(res.status==200){
                this.setState({lucky_wheel: res.data});
            }
            this.fetchCoupon();
        });
    }

    getOptions() {
        let coupons = [];
        if (this.state.coupons.length < 1) {
            return coupons;
        }
        this.state.coupons.map((d)=> {
            let duplicate = false;
            for (let i in this.state.selectedCoupons) {
                if (this.state.selectedCoupons[i].key == d.id) {
                    duplicate = true;
                    break;
                }
            }
            if (!duplicate) {
                coupons[coupons.length] = <Select.Option key={d.id}>{d.title + " " + d.content}</Select.Option>;
            }
        });
        return coupons;
    }

    fetchCoupon(keyword = '') {
        let filterQuery = 'title=' + keyword;
        const query = `is_lucky=1&page=1&per_page=15&${filterQuery}`;
        getCouponsList(query, (res) => {this.setState({
                coupons: res.data.data,
                selectedCoupons: this.defaultCoupons(res.data.data)
            })
        });

        // console.log('keyword', keyword);
    }

    commitCoupons(items) {
        let max = this.state.lucky_wheel.segment_count;
        let selectedCoupons = [];
        let start = 0;
        for (let i in items) {
            if (start < max) {
                selectedCoupons[selectedCoupons.length] = items[i];
            }
            else{
                alert("تعداد قرعه کشی ها نمی تواند بیتشر از " + max + " تا باشد.");
                break;
            }
            start++;
        }
        this.setState({selectedCoupons: selectedCoupons});
    }

    defaultCoupons(allCoupons) {
        if (!this.state.lucky_wheel.coupons) {
            return [];
        }
        let coupons = [];
        for (let j in this.state.lucky_wheel.coupons) {
            for (let i in allCoupons) {
                if (allCoupons[i].id == this.state.lucky_wheel.coupons[j].coupon_id) {
                    coupons[coupons.length] = {key: allCoupons[i].id, label: allCoupons[i].title};
                    break;
                }
            }
        }
        return coupons;
    }

    render(){
        if(this.state.lucky_wheel.id == undefined){
            return 'لطفا منتظر بمانید';
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        var coupons = this.getOptions();

        const { getFieldDecorator, getFieldsError } = this.props.form;

        return (
            <div style={{direction: 'rtl'}}>
                <Col span={20} offset={1}>
                    عنوان گردونه: {this.state.lucky_wheel.title}<br/>
                </Col>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="قرعه کشی"
                                colon={false}>
                                {getFieldDecorator('coupons', {
                                    initialValue: this.state.selectedCoupons,
                                    rules: [{
                                        required: true
                                    }]
                                })(
                                    <Select
                                        mode="multiple"
                                        labelInValue
                                        placeholder="انتخاب قرعه کشی"
                                        notFoundContent={this.state.loading ? <Spin size="small" >قرعه کشیی یافت نشد</Spin> : null}
                                        onSearch={this.fetchCoupon.bind(this)}
                                        onChange={this.commitCoupons.bind(this)}
                                        >
                                        {coupons}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item>
                                <div className="btn-container">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={hasErrors(getFieldsError()) || this.props.submitted}
                                        >
                                        {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                                    </Button>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
export default Form.create({ name: 'horizontal_login' })(LuckyWheelCouponForm);



// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/Coupons/form.js